import React from 'react';
import { NavLink } from 'react-router-dom';

const LINKS = [
  { to: '/equipment', label: 'Fleet', end: true },
  { to: '/equipment/board', label: 'Shop Board', end: true },
  { to: '/equipment/dashboard', label: 'Dashboard', end: true },
  { to: '/equipment/transfers', label: 'Transfers', end: false }
];

const EquipmentSubnav: React.FC = () => {
  return (
    <nav aria-label="Equipment sections" className="tw-mb-4 tw-flex tw-flex-wrap tw-gap-1 tw-border-b tw-border-line">
      {LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          className={({ isActive }) =>
            `-tw-mb-px tw-border-b-2 tw-px-3 tw-py-2 tw-text-sm tw-no-underline ${
              isActive
                ? 'tw-border-primary tw-font-medium tw-text-primary'
                : 'tw-border-transparent tw-text-content-secondary hover:tw-text-content'
            }`
          }
        >
          {link.label}
        </NavLink>
      ))}
    </nav>
  );
};

export default EquipmentSubnav;
